import styled from 'styled-components';

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  background: #f5f6fa;
  border-radius: 8px;
  padding: 0.8rem 2rem;

  span {
    color: #5d4e4f;
    font-size: 1.4rem;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);

    span:nth-child(3) {
      display: none;
    }
  }
`;

export const TableBody = styled.div``;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  background: #f2f2f2;
  border-radius: 8px;
  padding: 0.8rem 2rem;
  margin-bottom: 1rem;

  span {
    color: #000;
    font-size: 1.4rem;
    text-transform: uppercase;
    /* Truncate */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:first-of-type {
      color: #3eb589;
      font-weight: 700;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);

    span:nth-child(3) {
      display: none;
    }
  }
`;

export const EmptyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #f2f2f2;
  border-radius: 8px;
  padding: 0.8rem 2rem;

  color: #222;
  font-size: 1.4rem;
`;
